import './Loading.scss'
import {Page} from '../../layouts/page/Page'

export const Loading = () => {
    return (
        <Page id="loading">
            <h2>...</h2>
        </Page>
    )
}